import { NotificationUseCaseEnum } from '../../enums';

export class NotificationDataInterface {
  constructor(
    public readonly useCase: NotificationUseCaseEnum,
    public readonly useCaseSpecificData: { [key: string]: any }
  ) {}
}
